import { forwardRef, memo } from 'react';
import pick from 'lodash/pick';
import BsButton from 'react-bootstrap/Button';

import Icon from '../Icon';
import { buttonPropTypes } from './utils';
import type { ButtonProps } from './utils';

const Button = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const {
    variant = 'default',
    size,
    text,
    disabled,
    loading,
    children,
    addIconclassName,
    ...rest
  } = props;

  const iconStyle = !text ? null : { marginRight: '5px' };
  const icon = loading
    ? <Icon name='spinner' spin className={ addIconclassName } style={ iconStyle } />
    : <Icon name={ props.icon } className={ addIconclassName } style={ iconStyle } />;

  return (
    <BsButton
      { ...pick(rest, Object.keys(buttonPropTypes)) }
      ref={ ref }
      // 'default' — легаси-вариант вне union'ов react-bootstrap
      variant={ variant as any }
      size={ size }
      type={ props.type || 'button' }
      disabled={ disabled || loading }
    >
      { props.icon && icon }
      { text }

      { children }
    </BsButton>
  );
});

export default memo(Button);
